/**
 * Relative effort weights for the assembly checklist sections.
 *
 * Used in two places that should not depend on each other: AssemblyChecklist
 * renders a weighted progress bar from them, and stageTimeline distributes
 * unaccounted business time across stages in proportion to them.
 *
 * They live here rather than in the component because stageTimeline is pure
 * domain logic. Importing them from AssemblyChecklist.tsx dragged React and,
 * transitively, the Supabase client into anything that touched the timeline -
 * which made it untestable without a populated .env.
 *
 * Section keys match STAGE_TIMELINE_SECTIONS in lib/stageTimeline.ts and
 * CHECKLIST_SECTIONS in components/AssemblyChecklist.tsx.
 */
export const SECTION_WEIGHTS: Record<string, number> = {
  assembly: 35,
  software: 35,
  benchmarking: 20,
  finishing: 3,
  final_touches: 7,
};
